import { Types } from "@grandvisionhq/graphql";
const _PlaceOrderOperation = class _PlaceOrderOperation {
};
_PlaceOrderOperation.placeOrderInput = ({
  consents,
  analyticsId,
  paymentRequest,
  checkoutId,
  loginRedirectUrl,
  shouldCreateAccount,
  optIns,
  donationIntent,
  overwritePersonalDetails = false
}) => {
  const mappedOptIns = getOptIns(optIns);
  const mappedConsents = getConsents(consents);
  return {
    checkoutId,
    ...mappedConsents && mappedConsents.length ? { consents: mappedConsents } : {},
    payment: {
      analyticsId,
      ...getPaymentDetails(paymentRequest)
    },
    newAccountDetails: {
      ...loginRedirectUrl ? { loginRedirectUrl } : {},
      shouldCreateAccount,
      ...mappedOptIns.length ? { optIns: mappedOptIns } : {}
    },
    ...donationIntent ? {
      donationIntent
    } : {},
    overwritePersonalDetails
  };
};
_PlaceOrderOperation.placeOrderOutput = (responseData) => {
  let orderResult;
  const placeOrderResponse = {
    success: false,
    redirect: false
  };
  if (responseData && "placeOrder" in responseData) {
    orderResult = responseData.placeOrder;
    if (orderResult.__typename === "PlaceOrderMutationSuccessResponse") {
      const { paymentResponse } = orderResult;
      switch (paymentResponse.__typename) {
        case "PlaceOrderMutationVoucherPaymentResponse":
        case "PlaceOrderMutationEmptyPaymentResponse":
        case "PlaceOrderMutationDefaultPaymentResponse":
          if ([
            Types.ResultType.AUTHORISED,
            Types.ResultType.RECEIVED,
            Types.ResultType.PENDING,
            Types.ResultType.VOUCHER
          ].includes(paymentResponse.resultType)) {
            return {
              ...placeOrderResponse,
              orderDataToken: orderResult.orderDataToken,
              success: true,
              resultType: paymentResponse.resultType
            };
          }
          break;
        case "PlaceOrderMutationRedirectPaymentResponse":
          return {
            success: true,
            redirect: true,
            resultType: paymentResponse.resultType,
            redirectUrl: paymentResponse.redirectUrl,
            httpMethod: paymentResponse.httpMethod
          };
        case "PlaceOrderMutationQrCodePaymentResponse":
          return {
            ...placeOrderResponse,
            orderId: orderResult.order.id,
            orderDataToken: orderResult.orderDataToken,
            success: true,
            qrCodeExpiresIn: paymentResponse.qrCodeExpiresIn,
            qrCodeUrl: paymentResponse.qrCodeUrl,
            redirectUrl: paymentResponse.redirectUrl,
            resultType: paymentResponse.resultType
          };
        default:
          return placeOrderResponse;
      }
    } else {
      if (orderResult.__typename === "PlaceOrderMutationFailurePostOrderCreationResponse") {
        orderResult.failures.forEach((error) => {
          console.error(`[error]:`, error.code);
        });
        return {
          ...placeOrderResponse,
          cartHash: orderResult.newCheckoutHash,
          cartId: orderResult.newCheckoutId,
          status: "Failed"
        };
      }
      if (orderResult.__typename === "PlaceOrderMutationFailurePreOrderCreationResponse") {
        orderResult.failures.forEach((error) => {
          console.error(`[error]:`, error.code);
        });
        return {
          ...placeOrderResponse,
          status: "Failed"
        };
      }
      if (orderResult.__typename === "PlaceOrderMutationFailureRecalculatedCartResponse") {
        orderResult.failures?.forEach((error) => {
          console.error(`[error]:`, error.code);
        });
        return {
          ...placeOrderResponse,
          cartHash: orderResult.newCheckoutHash,
          cartId: orderResult.newCheckoutId,
          status: "Failed",
          productPriceUpdated: true
        };
      }
    }
  }
  return placeOrderResponse;
};
let PlaceOrderOperation = _PlaceOrderOperation;
const getConsents = (consentsInput) => {
  const consents = [];
  if (consentsInput) {
    for (const key in consentsInput) {
      const consent = consentsInput[key];
      consent && consent.literalText && consents.push({
        consentName: key,
        literalText: consent.literalText,
        uiElementType: Types.UIElementType.CHECKBOX
      });
    }
  }
  return consents;
};
const getOptIns = (optInsInput) => {
  const optIns = [];
  if (optInsInput) {
    for (const key in optInsInput) {
      const optIn = optInsInput[key];
      optIn && optIn.literalText && optIn.value && optIns.push({
        id: key,
        literalText: optIn.literalText,
        value: optIn.value,
        uiType: Types.UIType.CHECKBOX
      });
    }
  }
  return optIns;
};
const getPaymentDetails = ({
  paymentMethod,
  amount,
  paymentDetails,
  paymentServiceProvider,
  returnUrl
}) => {
  return {
    returnUrl,
    paymentMethod,
    psp: paymentServiceProvider,
    amount: {
      centAmount: amount.value,
      currencyCode: amount.currency
    },
    ...getPaymentData({ paymentDetails, paymentMethod })
  };
};
const getPaymentData = ({ paymentDetails, paymentMethod }) => {
  if (paymentDetails) {
    switch (paymentMethod.toUpperCase()) {
      case Types.PaymentMethod.BANCONTACT_CARD:
        return {
          bancontactCardDetails: paymentDetails
        };
      case Types.PaymentMethod.CREDITCARD:
        return {
          cardDetails: paymentDetails
        };
      case Types.PaymentMethod.APPLE_PAY:
        return {
          applePayDetails: paymentDetails
        };
      case Types.PaymentMethod.PAYPAL:
        return {
          paypalDetails: paymentDetails
        };
      case Types.PaymentMethod.MBWAY:
        return {
          mbwayDetails: paymentDetails
        };
      case Types.PaymentMethod.IDEAL:
        return {
          idealDetails: paymentDetails
        };
      case Types.PaymentMethod.GOOGLE_PAY:
        return {
          googlePayDetails: paymentDetails
        };
      case Types.PaymentMethod.SEPA_DIRECT_DEBIT:
        return {
          sepaDirectDebitDetails: paymentDetails
        };
      case Types.PaymentMethod.ONEY:
        return {
          oneyDetails: paymentDetails
        };
      case Types.PaymentMethod.FAKE:
        return {
          fakeDetails: paymentDetails
        };
      case Types.PaymentMethod.CASH_ON_DELIVERY:
        return {
          cashOnDeliveryDetails: paymentDetails.paymentMethodPrice
        };
      default:
        return null;
    }
  }
  return null;
};
export {
  PlaceOrderOperation
};
//# sourceMappingURL=place-order-operation-mapper.js.map
